export const translate = (text) => {
    if (typeof C_Translates !== 'undefined' && C_Translates[text]) return C_Translates[text];
    $.ajax({
        url: ABSOLUTE_URL+ `classes/languages.php?language-id=${CLangId}`,
        type: "POST",
        dataType: 'html',
        data: {"translate":text}
    });
    return text;
}